import { render, staticRenderFns } from "./sisPageLoader.vue?vue&type=template&id=6ad1241f&scoped=true"
import script from "./sisPageLoader.vue?vue&type=script&lang=js"
export * from "./sisPageLoader.vue?vue&type=script&lang=js"
import style0 from "./sisPageLoader.vue?vue&type=style&index=0&id=6ad1241f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad1241f",
  null
  
)

export default component.exports